import { compose, withHandlers, withState, withProps } from 'recompose'
import { connect } from 'react-redux'
import NewValuePropositionWrapper from './NewValuePropositionWrapper'
import { showNewShopTiresModal } from 'components/NewShopTiresModal/actions'
import withRequestApptClick from 'components/common/hoc/withRequestApptClick'
import { MAIN_YMME_SOURCE, SCHEDULE_APPOINTMENT_TITLE, APPOINTMENT_TITLE, INITIAL_HOVER_DATA } from '../../constant'
import withNavigateToTireSearchOrShowYmme from 'components/common/hoc/withNavigateToTireSearchOrShowYmme'
import withShowConfirmTireSizeModalPreconfigured from 'components/common/hoc/withShowConfirmTireSizeModalPreconfigured'
import withTrailerFlags from 'components/common/hoc/withTrailerFlags'
import { getCurrentStoreIsE2EAppointment } from 'selectors/getCurrentStore'
import { isDesktop } from 'components/common/Media/helpers'

const withHoverState = withState('hover', 'setHover', INITIAL_HOVER_DATA)

const mapStateToProps = (state) => ({
  isE2EAppointment: getCurrentStoreIsE2EAppointment(state)
})

const withValuePropositionHandlers = withHandlers({
  onMouseEnterHandler: ({ setHover, isDesktop }) => (alt) => {
    isDesktop && setHover({
      ...INITIAL_HOVER_DATA,
      [alt]: true
    })
  },
  onMouseLeaveHandler: ({ setHover, isDesktop }) => () => {
    isDesktop && setHover(INITIAL_HOVER_DATA)
  },
  showNewYMMEModal: ({ showNewShopTiresModal, hasActiveVehicle, navigateToTireSearchOrShowYmme, isTrailer }) => () => {
    (hasActiveVehicle && !isTrailer)
      ? navigateToTireSearchOrShowYmme()
      : showNewShopTiresModal({ ymmeName: MAIN_YMME_SOURCE })
  }
})

const withIsDesktop = withProps(() => ({
  isDesktop: isDesktop()
}))

const withConfigureHandleShopByVehicleClick = withProps(({ onClick, showNewYMMEModal, isE2EAppointment }) => ({
  handleShopByVehicleClick: onClick || showNewYMMEModal,
  appointmentTitle: isE2EAppointment ? SCHEDULE_APPOINTMENT_TITLE : APPOINTMENT_TITLE
}))

export default compose(
  connect(mapStateToProps, { showNewShopTiresModal }),
  withProps(() => ({ navigateToQuickApptPage: true })),
  withTrailerFlags,
  withHoverState,
  withNavigateToTireSearchOrShowYmme,
  withIsDesktop,
  withValuePropositionHandlers,
  withShowConfirmTireSizeModalPreconfigured,
  withConfigureHandleShopByVehicleClick,
  withRequestApptClick
)(NewValuePropositionWrapper)
